
    const mBody = document.getElementsByTagName('body')[0]
    function scrollHeightCheck() {
        window.scrollY >= 100 ? mBody.classList.add('scrolled') 
                         : mBody.classList.remove('scrolled')
    }
    document.onscroll = function() { scrollHeightCheck() }
    scrollHeightCheck()


const videos = document.querySelectorAll('video[autoplay]')

var motionQuery = matchMedia('(prefers-reduced-motion: reduce)');

function handleReduceMotionChanged() {
  if(videos) {
     videos.forEach(function (video, index) {
    if (motionQuery.matches) {
        video.removeAttribute('autoplay')
        
      
    } else {
       
       
    }

    });    
   }}

                    

motionQuery.addEventListener("change", handleReduceMotionChanged)

handleReduceMotionChanged(); // trigger once on load


// Skip initializing infinite scroll when restoring from cache
if (sessionStorage.getItem('skipInfiniteScroll')) {
  sessionStorage.removeItem('skipInfiniteScroll');
} else {
  document.addEventListener('DOMContentLoaded', function () {
    initInfiniteScroll();
  });
}


function initInfiniteScroll() {
  let isInProgress = false;

  function scrollHandler() {
    const footer = document.querySelector("#section-power-footer");
    const loadMoreWrap = document.querySelector(".load-more_wrap");

    if (!footer || !loadMoreWrap || isInProgress) return;

    const footerTop = footer.getBoundingClientRect().top + window.pageYOffset;

    if ((window.pageYOffset + window.innerHeight) >= footerTop) {
      isInProgress = true;

      const totalPages = parseInt(loadMoreWrap.getAttribute("data-all-pages"));
      const currentPage = parseInt(loadMoreWrap.getAttribute("data-this-page"));
      const datacollurl = loadMoreWrap.getAttribute("data-coll-url");
      const nextPage = currentPage + 1;

      if (currentPage >= totalPages) return;

      // ✅ Preserve all active filters + sort
      const urlParams = new URLSearchParams(window.location.search);
      urlParams.set('page', nextPage);
      const nextUrl = `${datacollurl}?${urlParams.toString()}`;

      // Update page tracking
      loadMoreWrap.setAttribute("data-this-page", nextPage);

      fetch(nextUrl)
        .then(res => res.text())
        .then(html => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const newItems = doc.querySelector('.grid-uniform_js')?.innerHTML;
         if (newItems) {
            const grid = document.querySelector(".grid-uniform_js");
            grid.insertAdjacentHTML('beforeend', newItems);

            // ✅ Dispatch an event every time new products are appended
            document.dispatchEvent(new CustomEvent('collection:updated', {
              detail: {
                page: nextPage,
                total: totalPages,
                items: grid.children.length
              }
            }));
          }


          if (nextPage >= totalPages) {
            loadMoreWrap.remove();
          }
        })
        .finally(() => {
          isInProgress = false;
        });
    }
  }

  window.removeEventListener('scroll', scrollHandler); // prevent stacking
  window.addEventListener('scroll', scrollHandler);
}

